import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import './CompaniesNav.css';

// Allow quick navigation to headers in the form
class CompaniesNav extends React.Component {
  static propTypes = {
    location: PropTypes.object
  };

  render() {
    return (
      <div className='CompaniesNav-root'>
        <h2 className='CompaniesNav-header'>Quick Nav</h2>
        <Link className='CompaniesNav-link' to={'#list'}>Companies List</Link>
        <Link className='CompaniesNav-link' to={'#feature'}>Front Page Feature</Link>
        <Link className='CompaniesNav-link' to={'#industry'}>Industry Tag</Link>
      </div>
    );
  }
}

const connectedCompaniesNav = connect(
  (state) => ({
    location: state.router.location
  })
)(CompaniesNav);

export default connectedCompaniesNav;



// WEBPACK FOOTER //
// ./src/components/companies/CompaniesNav/CompaniesNav.js